import { tDiscountPercent } from "../../interfaces";

export enum eUIActionTypes{
	CLEAR_STATE = 'UI/CLEAR_STATE',
	SET_IS_DEPOSIT_AVAILABLE = 'UI/SET_IS_DEPOSIT_AVAILABLE',
}

export type tUIAction = 
	iClearStateAction |
	iSetIsDepositAvailableAction
;

interface iClearStateAction {
	type: eUIActionTypes.CLEAR_STATE,
}

interface iSetIsDepositAvailableAction {
	type: eUIActionTypes.SET_IS_DEPOSIT_AVAILABLE,
	payload: {
		percent: tDiscountPercent,
		state: boolean,
	}
}